import axios from "axios";

export const fetchMoreDetails = async (globalId) => {
  try {
    const response = await axios.get(
      `https://cdn-gateflipp.flippback.com/item-details/ecom/multi`,
      {
        params: { global_ids: globalId },
      }
    );
    const result = response.data?.ecom_items;

    if (result && result.length > 0) {
      return result[0];
    }
    return null;
  } catch (error) {
    console.error("Error fetching Buy Now URL:", error);
    return null;
  }
};